import Portal from 'preact-portal'
import flowtip from 'flowtip-core'
import preact from 'preact'
import CSSTransitionGroup from 'preact-css-transition-group'

const showDelay = 70
const hideDelay = 300
const showIndex = 1025
const initialIndex = 1024

class Popup extends preact.Component {
  constructor (props) {
    super(props)
    if (props.triggerOnClick) {
      props.hoverControl.addEventListener('click', e => {
        e.preventDefault()
        this.show()
      })
      document.addEventListener('click', (e) => {
        let popup = document.body.querySelector('.popup-component')
        if (!popup) return
        if (!popup.contains(e.target)) {
          this.hide()
        }
      })
    } else {
      props.hoverControl.addEventListener('mouseover', () => this.show())
      props.hoverControl.addEventListener('mouseout', () => this.hide())
    }

    this.state = { zIndex: initialIndex, triggerOnClick: props.triggerOnClick }
  }

  show () {
    clearTimeout(this.hideTimeout)
    if (this.state.show) return
    this.showTimeout = setTimeout(() => {
      if (this.state.show) return

      const bodyRect = window.document.body.getBoundingClientRect()
      const { rect } = flowtip({
        target: this.props.hoverControl.getBoundingClientRect(),
        content: this.props.size,
        bounds: bodyRect,
        disabled: { left: true, right: true, top: true }
      })
      this.setState({
        show: true,
        left: Math.floor(rect.left - bodyRect.left),
        top: Math.floor(rect.top - bodyRect.top),
        bodyRect,
        zIndex: showIndex
      })
    }, showDelay)
  }

  hide () {
    clearTimeout(this.hideTimeout)
    clearTimeout(this.showTimeout)
    this.setState({ zIndex: initialIndex })
    this.hideTimeout = setTimeout(() => this.setState({ show: false }), hideDelay)
  }

  toggle (on) {
    if (!this.state.triggerOnClick) {
      on ? this.show() : this.hide()
    }
  }

  render ({ children, hoverControl }, { show, left, top, zIndex }) {
    return (
      <Portal into={'body'}>
        <CSSTransitionGroup transitionName='popup-transition' transitionEnterTimeout={150} transitionLeaveTimeout={150}>
          {show
            ? <div class='popup-component'
              onMouseLeave={() => {
                this.toggle(false)
              }}
              onMouseEnter={() => {
                this.toggle(true)
              }}
              style={{
                left,
                top,
                width: `${this.props.size.width}px`,
                zIndex: zIndex
              }} >
              {children}
            </div>
            : null}
        </CSSTransitionGroup>
      </Portal>
    )
  }
}

export default Popup
